const module = {
  config: {
    name: "pengaturan-pengguna",
    svg: "../static/img/icon/menu/user-settings-fill.svg",
    desc: "Berisi modul pengaturan akses pengguna.",
    layout: true
  },
  routes: [
    {
      name: "users",
      icon: "ri-user-fill",
      path: "/users",
      component: () => import("./users.vue")
    },
    {
      name: "roles",
      icon: "ri-file-user-fill",
      path: "/roles",
      component: () => import("./roles.vue")
    },
    {
      name: "role-groups",
      icon: "ri-folder-user-fill",
      path: "/role-groups",
      component: () => import("./role-groups.vue")
    },
    {
      name: "tasks",
      icon: "ri-list-check-3",
      path: "/tasks",
      component: () => import("./tasks.vue")
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/user-role/_index.js